import { Text } from "@wayflyer/flyui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";

import { MESSAGES } from "../message-definitions";

export const BusinessModelGeoLetDown = ({
  eligibilityLink,
  isMultiSelectBusinessModelFlow,
}: {
  eligibilityLink: ReactNode;
  isMultiSelectBusinessModelFlow: boolean;
}) => {
  const intl = useIntl();

  return (
    <Text>
      {intl.formatMessage(
        isMultiSelectBusinessModelFlow
          ? MESSAGES.letDownReasonBusinessModelGeoMultiSelect
          : MESSAGES.letDownReasonBusinessModelGeo
      )}{" "}
      {eligibilityLink}
    </Text>
  );
};
